import { render, staticRenderFns } from "./cleancarService.vue?vue&type=template&id=175dacb4&scoped=true"
import script from "./cleancarService.vue?vue&type=script&lang=js"
export * from "./cleancarService.vue?vue&type=script&lang=js"
import style0 from "./cleancarService.vue?vue&type=style&index=0&id=175dacb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175dacb4",
  null
  
)

export default component.exports